import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  active?: boolean;
  onClick?: () => void;
}

export default function ButtonLink({ label, active, onClick }: Props) {
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        background: 'transparent',
        border: 0,
        textAlign: 'left',
        cursor: 'pointer',
        px: 0,
        py: 0.5,
        width: '100%'
      }}
    >
      <Typography sx={{ fontSize: '0.95rem', color: active ? '#fff' : '#4B5563', backgroundColor: active ? '#492728' : 'transparent', padding: active ? '0.25rem 0.5rem' : '', borderRadius: active ? '0.5rem' : '0', fontWeight: active ? 600 : 400 }}>{label}</Typography>
    </Box>
  );
}
